import { render, staticRenderFns } from "./UserRoleHelp.vue?vue&type=template&id=41c4a16a&"
import script from "./UserRoleHelp.vue?vue&type=script&lang=js&"
export * from "./UserRoleHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports